import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AriaLiveService {
  currentAriaLiveText = signal<string>('');
}
